let isInViewport = function (element) {
    const rect = element.getBoundingClientRect();
    const html = document.documentElement;

    return (
        rect.top >= 0 &&
        rect.top <= (window.innerHeight || html.clientHeight) * 0.9
        // rect.bottom <= (window.innerHeight || html.clientHeight)
        );
};
//let watchedElements = document.querySelectorAll('.checkViewport');
const watchedElements = Array.prototype.slice.call(document.querySelectorAll('.check-viewport'));

const scrollHandler = function (e) {
    for (let i = 0; i < watchedElements.length; i++) {
        if (isInViewport(watchedElements[i])) {
            watchedElements[i].classList.add("is-in-viewport");
            watchedElements.splice(i, 1);
        }
    }
    if (!watchedElements.length) {
        window.removeEventListener('scroll', scrollHandler);
    }
};
if (watchedElements.length) {
    window.addEventListener('scroll', scrollHandler);
    document.addEventListener('DOMContentLoaded', scrollHandler);
}



// WEBPACK FOOTER //
// ./assets/js/src/modules/inViewport.js